export default async function retry (callback, reqInterval = 5000, times = 3) {
  let numberOfTries = 0;
  try {
    const initialCallResolved = await callback();
    return initialCallResolved;
  } catch (e) {
    return new Promise((resolve, reject) => {
      const interval = setInterval(async () => {
        numberOfTries++;
        (numberOfTries === times) && clearInterval(interval);

        try {
          const result = await callback();
          clearInterval(interval);
          resolve(result);
        } catch (err) {
          console.log(`Unsuccessful \n ${err}`);
          if (numberOfTries === times) reject(err);
        }
      }, reqInterval);
    });
  }
}
